<template>
  <section class="section">
    <div class="container">
      <div class="tabs is-right">
        <ul>
          <router-link tag="li" :to="{ name: 'settings.pventa'}">
            <a>P Venta</a>
          </router-link>
          <router-link tag="li" :to="{ name: 'settings.terceros'}">
            <a>Terceros</a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Preferencias</h1>
          <h2 class="subtitle is-6">Preferencias del usuario</h2>
          <p>Aquí podrá configurar las diferentes opciones para utilizar el sistema</p>
        </div>
      </div>

      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      routeaqui: null,
    };
  },
  computed: {
    isinicial() {
      return this.$route.name === "settings";
    },
  },
  created() {
    this.routeaqui = this.$route.name;
  },
};
</script>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  color: #3273dc;
  border-bottom-width: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Settings.vue